import React from "react";
import { DELIVERY_ROUTE_COLOR, LOADING_ROUTE_COLOR } from "../utils/routeModelsData.js";

const SEGMENT_ITEMS = [
  { key: "loading", color: LOADING_ROUTE_COLOR, label: "Chargement" },
  { key: "delivery", color: DELIVERY_ROUTE_COLOR, label: "Livraison" },
];

const COMPACT_SEGMENT_ITEMS = [
  { key: "loading", color: LOADING_ROUTE_COLOR, label: "Chg." },
  { key: "delivery", color: DELIVERY_ROUTE_COLOR, label: "Livr." },
];

const POINT_ITEMS = [
  { key: "start", className: "trip-stop-legend__dot--start", label: "Entrepôt" },
  { key: "loading", className: "trip-stop-legend__dot--loading", label: "Chargement" },
  { key: "delivery", className: "trip-stop-legend__dot--delivery", label: "Livraison" },
];

const COMPACT_POINT_ITEMS = [
  { key: "start", className: "trip-stop-legend__dot--start", label: "Dépôt" },
  { key: "loading", className: "trip-stop-legend__dot--loading", label: "Chg." },
  { key: "delivery", className: "trip-stop-legend__dot--delivery", label: "Livr." },
];

export default function RouteLegend({ compact = false, stopBadgePresentation = "number", trip = null }) {
  if (!trip) {
    return (
      <div className="route-map-legend" aria-live="polite">
        <span className="route-map-legend__empty">Sélectionnez une tournée pour afficher la carte.</span>
      </div>
    );
  }

  const segmentItems = compact ? COMPACT_SEGMENT_ITEMS : SEGMENT_ITEMS;
  const pointItems = stopBadgePresentation === "number"
    ? [{ key: "stop", className: "trip-stop-legend__dot--stop", label: "Arrêt" }]
    : compact ? COMPACT_POINT_ITEMS : POINT_ITEMS;

  return (
    <div
      className="route-map-legend"
      aria-label="Légende de la carte de route"
      data-route-map-legend-compact={compact ? "true" : undefined}
    >
      <div className="route-map-legend__row">
        <span className="route-map-legend__label">Segments</span>
        <div className="route-map-legend__items">
          {segmentItems.map((item) => (
            <div key={item.key} className="route-map-legend__item">
              <span
                className="route-map-legend__swatch route-map-legend__swatch--route"
                style={{ "--route-segment-color": item.color }}
              />
              <span>{item.label}</span>
            </div>
          ))}
        </div>

        <div className="trip-stop-legend trip-stop-legend--map-inline">
          {pointItems.map((item) => (
            <div key={item.key} className="trip-stop-legend__item">
              <span className={`trip-stop-legend__dot ${item.className}`} />
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
